import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map } from 'rxjs/operators';
import { environment } from '../../environments/environment';
import { AuthService } from './auth.service';
import { BillsOnlinePaymentResponse, ReporteFactura } from '../models/bills-to-online-payment.model';
import { Observable } from 'rxjs';
import { CiCdConfigService } from 'src/cicd/ci-cd-config.service';

@Injectable({
  providedIn: 'root'
})
export class PaymentsService {

  public headers: HttpHeaders;
  public userData: any;
  private urlApi: string;
  public userId: any = { documento: 0, tipo_documento: '' };

  constructor(private http: HttpClient,
    private auth: AuthService,
    private readonly ciCd: CiCdConfigService
  ) { 
    // this.urlApi = environment.urlApi; // PREJENKINS
    this.ciCdInit();
    this.initializeHeaders();
   }

  ciCdInit() {
    this.ciCd.loadConfigurations().subscribe(({ apis }: any) => {
      const { urlApi } = apis;
      this.urlApi = urlApi;
    });
  }

  initializeHeaders() {
    this.userData = JSON.parse(localStorage.getItem("identityCVE"));
    this.headers = new HttpHeaders();
    this.headers.append("Content-Type", "multipart/form-data");
    this.headers.append("Accept", "application/x-www-form-urlencoded");
    this.headers = this.headers.set("token", localStorage.getItem("tokenCVE"));
    this.userData = JSON.parse(localStorage.getItem("identityCVE"));

  }

  getReport(params: any) {
    return this.http.get('/api/payments/report');
  }

  getOnlinePaymentsByDay() {
    this.userId = this.auth.getDocument();
    const headers = this.headers;
    const options = { params: this.userId, headers };

    return this.http.get(`${this.urlApi}/pr_online_payments_by_day`, options)
      .pipe(
        map(onlinePaymentsByDay => onlinePaymentsByDay)
      );
  }

  getBankPaymentsByDay() {
    this.userId = this.auth.getDocument();
    const headers = this.headers;
    const options = { params: this.userId, headers };

    return this.http.get(`${this.urlApi}/pr_bank_payments_by_day`, options)
      .pipe(
        map(bankPaymentsByDay => bankPaymentsByDay)
      );
  }

  getPaymentsCountVsAmount() {
    this.userId = this.auth.getDocument();
    const headers = this.headers;
    const options = { params: this.userId, headers };

    return this.http.get(`${this.urlApi}/pr_payments_count_vs_amount`, options)
      .pipe(
        map(paymentsCountVsAmount => paymentsCountVsAmount)
      );
  }

  getPaymentsTable(paymentsRequest: any) {
    this.userId = this.auth.getDocument();
    const { currentPage, perPage } = paymentsRequest;
    const headers = this.headers;

    const params = { ...this.userId, currentPage, perPage };
    let options = { params, headers };

    return this.http.get(`${this.urlApi}/pr_get_payments_table`, options)
      .pipe(
        map(payments => payments)
      );
  }

  getPaymentsFile() {
    this.userId = this.auth.getDocument();
    const headers = this.headers;
    const params = { ...this.userId };
    let options = { params, headers };

    return this.http.get(`${this.urlApi}/pr_get_payments_file`, options)
      .pipe(
        map(payments => payments)
      );
  }


  getBillsToPayment(): Observable<ReporteFactura[]> {
    this.userId = this.auth.getDocument();
    const headers = this.headers;
    const params = { tipo_doc_afiliado: this.userId.tipo_documento, doc_afiliado: this.userId.documento };
    let options = { params, headers };

    return this.http.get<BillsOnlinePaymentResponse>(`${this.urlApi}/pr_reporte_facturas_x_pagar`, options)
      .pipe(
        map((response: BillsOnlinePaymentResponse) => response.REPORTE_FACTURAS)
      );
  }


}
